/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The subject of an AgentPresenceEvent.
 */
export type AgentEventSubject = {
  /**
   * Universally unique identifier
   */
  agentId: string;
  /**
   * Universally unique identifier
   */
  orgId: string;
};

/** @internal */
export const AgentEventSubject$inboundSchema: z.ZodType<
  AgentEventSubject,
  z.ZodTypeDef,
  unknown
> = z.object({
  agent_id: types.string(),
  org_id: types.string(),
}).transform((v) => {
  return remap$(v, {
    "agent_id": "agentId",
    "org_id": "orgId",
  });
});
/** @internal */
export type AgentEventSubject$Outbound = {
  agent_id: string;
  org_id: string;
};

/** @internal */
export const AgentEventSubject$outboundSchema: z.ZodType<
  AgentEventSubject$Outbound,
  z.ZodTypeDef,
  AgentEventSubject
> = z.object({
  agentId: z.string(),
  orgId: z.string(),
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
    orgId: "org_id",
  });
});

export function agentEventSubjectToJSON(
  agentEventSubject: AgentEventSubject,
): string {
  return JSON.stringify(
    AgentEventSubject$outboundSchema.parse(agentEventSubject),
  );
}
export function agentEventSubjectFromJSON(
  jsonString: string,
): SafeParseResult<AgentEventSubject, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AgentEventSubject$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AgentEventSubject' from JSON`,
  );
}
